<template>
    <div class="atelier-plugin-container">
        <CommonComponentsProductsAtelierSimulatorCardAndPic
            :function-title="functionTitle"
            :data="data"
            :text-list="textList"
        />
    </div>
</template>
<script lang="ts" setup>
    import bgImage from '@assets/imgs/Products/AtelierSimulator/Card/bgc2.jpg';

    const data = reactive({
        bgImage,
        colorIndex: 5,
        picCoverText: 'global_atelier_swipper_greentext',
    });
    const functionTitle: FunctionTitle = {
        colorTitle: 'global_atelier_colorTitle_1',
        title: 'global_atelier_plugin_title',
    };
    const textList: Array<FunctionTitle> = [
        {
            title: 'global_atelier_plugin_card_title_0',
            subtitle: 'global_atelier_plugin_card_subtitle_0',
        },
        {
            title: 'global_atelier_plugin_card_title_1',
            subtitle: 'global_atelier_plugin_card_subtitle_1',
        },
        {
            title: 'global_atelier_plugin_card_title_2',
            subtitle: 'global_atelier_plugin_card_subtitle_2',
        },
    ];
</script>

<style lang="less" scoped>
    :deep(.atelier-card) {
        height: .convert(796px) [ @vw] !important; //
        .atelier-card-button {
            margin-top: .convert(90px-64px) [ @vw] !important;
            button {
                &:hover {
                    background: #00ff00 !important;
                }
            }
        }
    }
    .atelier-plugin-container {
        margin-top: .convert(118px) [ @vw];
        margin-bottom: .convert(153px) [ @vw];
    }
</style>
